import { Alert, AlertColor, Snackbar } from '@mui/material';

interface MessagebarProps {
  open: boolean;
  severity: AlertColor;
  message: string;
}
export const MessageBar = (props: MessagebarProps) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={props.open}
    >
      <Alert severity={props.severity}>{props.message}</Alert>
    </Snackbar>
  );
};
